import { Component } from '@angular/core';
import { JhiLanguageService } from 'ng-jhipster';

@Component({
    selector: 'dcs-docs',
    templateUrl: './docs.component.html'
})
export class DcsDocsComponent {
    constructor (
        private jhiLanguageService: JhiLanguageService
    ) {
        this.jhiLanguageService.setLocations(['global']);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/docs/docs.component.ts